import { render, staticRenderFns } from "./EventQuiz.vue?vue&type=template&id=a461e268&scoped=true&lang=pug&"
import script from "./EventQuiz.vue?vue&type=script&lang=js&"
export * from "./EventQuiz.vue?vue&type=script&lang=js&"
import style0 from "./EventQuiz.vue?vue&type=style&index=0&id=a461e268&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a461e268",
  null
  
)

component.options.__file = "EventQuiz.vue"
export default component.exports